// src/components/Footer.js
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white shadow mt-6 p-4 flex flex-col items-center text-sm text-gray-600">
      <div className="space-x-4">
        {/* <Link to="/impressum" className="hover:underline">
          Impressum
        </Link> */}
        <Link to="/privacy" className="hover:underline">
          Privacy Policy
        </Link>
        <Link to="/gdpr" className="hover:underline">
          GDPR Compliance
        </Link>
      </div>
      <p className="mt-2">© {new Date().getFullYear()} PairLingo. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
